declare namespace $ {

	type $mol_view__sub_bog_ui_app_sidebar_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sidebar_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sidebar_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['set_dock'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sidebar_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sidebar_5 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['set_rail'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sidebar_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sidebar_7 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['set_hidden'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sidebar_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sidebar_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sidebar_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_sidebar_11 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['Preview_icon_home'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_sidebar_12 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_sidebar_13 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['Preview_icon_users'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_sidebar_14 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar_item__Icon_bog_ui_app_sidebar_15 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['Preview_icon_settings'] >
		,
		ReturnType< $bog_ui_sidebar_item['Icon'] >
	>
	type $bog_ui_sidebar_item__label_bog_ui_app_sidebar_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sidebar_item['label'] >
	>
	type $bog_ui_sidebar__mode_bog_ui_app_sidebar_17 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sidebar['preview_mode'] >
		,
		ReturnType< $bog_ui_sidebar['mode'] >
	>
	type $bog_ui_sidebar__items_bog_ui_app_sidebar_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sidebar['items'] >
	>
	type $mol_view__sub_bog_ui_app_sidebar_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sidebar_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_sidebar extends $mol_page {
		description( ): string
		Description( ): $mol_view
		mode_title( ): string
		Mode_title( ): $mol_view
		set_dock( next?: any ): any
		dock_label( ): string
		Dock_button( ): $mol_button_minor
		set_rail( next?: any ): any
		rail_label( ): string
		Rail_button( ): $mol_button_minor
		set_hidden( next?: any ): any
		hidden_label( ): string
		Hidden_button( ): $mol_button_minor
		Mode_buttons( ): $mol_view
		current_mode_text( ): string
		Current_mode( ): $mol_view
		preview_mode( next?: string ): string
		Preview_icon_home( ): $mol_icon_home
		Preview_item_home( ): $bog_ui_sidebar_item
		Preview_icon_users( ): $mol_icon_account
		Preview_item_users( ): $bog_ui_sidebar_item
		Preview_icon_settings( ): $mol_icon_cog
		Preview_item_settings( ): $bog_ui_sidebar_item
		Preview_sidebar( ): $bog_ui_sidebar
		preview_content_text( ): string
		Preview_content( ): $mol_view
		Preview( ): $mol_view
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=sidebar.view.tree.d.ts.map